import React, {ChangeEvent} from 'react';
import {Box, Typography, theme} from '@ttx/design-system';
import ReactAutocomplete from 'react-autocomplete';
import countries from './countries.json';

interface SelectCountryFieldProps {
  label?: string;
  placeholder?: string;
  countrySelected: string;
  setIsNorthAmerica: (value: boolean) => void;
  setFieldValue: (country: string, e: string | ChangeEvent<any>) => void;
  onBlur: (e: any) => void;
  error?: string;
}

export const SelectCountryField: React.FC<SelectCountryFieldProps> = ({
  label = 'Country',
  placeholder = 'Country',
  countrySelected,
  setFieldValue,
  setIsNorthAmerica,
  onBlur,
  error,
}: SelectCountryFieldProps) => {
  return (
    <Box>
      <Box pb="s">
        <Typography textStyle="s" color="textDefault">
          {label}
        </Typography>
      </Box>
      {/* @ts-expect-error react-autocomplete fix */}
      <ReactAutocomplete
        wrapperStyle={{
          position: 'relative',
          zIndex: 1,
        }}
        items={countries}
        shouldItemRender={(item, value) =>
          item.text.toLowerCase().indexOf(value.toLowerCase()) > -1
        }
        getItemValue={(item) => item.text}
        renderInput={(props) => (
          <input
            {...props}
            value={countrySelected}
            placeholder={placeholder}
            style={{
              width: '100%',
              boxSizing: 'border-box',
              background: theme.colors.transparent,
              border: `1px solid ${theme.colors.outlines}`,
              fontFamily: theme.fonts.abc,
              padding: theme.space.two,
              color: theme.colors.textDefault,
            }}
            onBlur={(e) => {
              if (props.onBlur) {
                props.onBlur(e);
              }
              onBlur(e);
            }}
          />
        )}
        renderMenu={(children) => (
          <Box
            backgroundColor="surfaceDark"
            cursor="pointer"
            borderColor="outlines"
            borderStyle="solid"
            borderWidth="one"
            borderTopWidth="zero"
            borderBottomWidth={!children.length ? 'zero' : 'one'}
            css={{marginTop: '-2px'}}
            maxHeight={125}
            overflowY="scroll"
            position="absolute"
            top={35.5}
            left={0}
            right={0}
          >
            <>{children}</>
          </Box>
        )}
        renderItem={(item, isHighlighted) => (
          <Box
            borderTopColor="outlines"
            borderTopStyle="solid"
            borderTopWidth="one"
            paddingY="s"
            paddingX="md"
            key={item.text}
          >
            <Typography
              color={isHighlighted ? 'textLow' : 'textDefault'}
              textStyle="s"
            >
              {item.text}
            </Typography>
          </Box>
        )}
        value={countrySelected}
        onChange={(e) => {
          const country = e.target.value;
          if (country === 'Canada' || country === 'United States') {
            setIsNorthAmerica(true);
          } else setIsNorthAmerica(false);
          setFieldValue('country', country);
        }}
        onSelect={(val) => {
          const country = val;
          if (country === 'Canada' || country === 'United States') {
            setIsNorthAmerica(true);
          } else setIsNorthAmerica(false);
          setFieldValue('country', val);
        }}
      />
      <Box pt="s" minHeight="24px">
        <Typography textStyle="s" color="errorPrimary">
          {error}
        </Typography>
      </Box>
    </Box>
  );
};
